module.exports = __webpack_public_path__ + "static/media/NU.808598bb.svg";